// components/workspace-timeline/WorkspaceTimelineLaneList.tsx
import React from 'react';
import { WorkspaceTimelineLaneRow } from './WorkspaceTimelineLaneRow';
import { WorkspaceTimelineVolumeOverlay } from './WorkspaceTimelineVolumeOverlay';
import type {
  TimelineLaneLayoutPresentation,
  TimelineLaneRowActions,
  TimelineRangePresentation,
  TimelineToolState,
  TimelineVolumeActions,
  WorkspaceTimelineLanePresentationRow,
} from './types';

interface WorkspaceTimelineLaneListProps {
  rows: WorkspaceTimelineLanePresentationRow[];
  range: TimelineRangePresentation;
  layout: TimelineLaneLayoutPresentation;
  tools: TimelineToolState;
  actions: TimelineLaneRowActions;
  volumeActions: TimelineVolumeActions;
}

export const WorkspaceTimelineLaneList = React.memo(({
  rows,
  range,
  layout,
  tools,
  actions,
  volumeActions,
}: WorkspaceTimelineLaneListProps) => {
  return (
    <>
      {rows.map((lanePresentationRow) => (
        <React.Fragment key={lanePresentationRow.previewLayerId}>
          <WorkspaceTimelineLaneRow
            row={lanePresentationRow}
            range={range}
            layout={layout}
            tools={tools}
            actions={actions}
          />
          {lanePresentationRow.volumeOverlayTrack && (
            <WorkspaceTimelineVolumeOverlay
              key={`${lanePresentationRow.volumeOverlayTrack.layerId}-volume`}
              trackId={lanePresentationRow.volumeOverlayTrack.layerId}
              trackName={lanePresentationRow.volumeOverlayTrack.name}
              startMs={lanePresentationRow.volumeOverlayTrack.startMs}
              activeDurationMs={lanePresentationRow.volumeOverlayTrack.activeDurationMs}
              audioGain={lanePresentationRow.volumeOverlayTrack.audioGain}
              laneLeftColumnWidthPx={layout.laneLeftColumnWidthPx}
              timelineRenderRangeStartMs={range.startMs}
              timelineRenderRangeMs={range.rangeMs}
              onChange={volumeActions.onChange}
              onFinalize={volumeActions.onFinalize}
            />
          )}
        </React.Fragment>
      ))}
    </>
  );
});

WorkspaceTimelineLaneList.displayName = 'WorkspaceTimelineLaneList';
